var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"mx-2"},[_c('span',{staticClass:"form-stepper-circle"},[_c('span',[_vm._v(_vm._s(_vm.step))])]),_c('div',{staticClass:"label text-white"},[_vm._v(_vm._s(_vm.$t(_vm.label)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }